// src/pages/Invoices/Report/PurchaseItemsDetailReport.jsx
import React from "react";
import ItemsDetailReport, { PURCHASE_DETAIL } from "../../../components/Reports/ItemsDetailReport";

export default function PurchaseItemsDetailReport() {
  return <ItemsDetailReport config={PURCHASE_DETAIL} />;
}
